import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "purchase-list" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onClick", "textContent"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "total"
}

import { computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Actions, Mutations } from '@/store';
import { formatPrice } from '@/core/filters';
import { PurchaseType } from '@/models/purchase.model';
import PurchaseItem from '@/components/purchases/PurchaseItem.vue';
import TimeToolbar from '@/components/toolbar/TimeToolbar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseList',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const year = computed<number>(() => store.state.year);
const filteredPurchases = computed(() => store.getters.filteredPurchases);
const purchaseTotal = computed<number>(() => store.getters.purchaseTotal);

const type = computed<string>(() => {
  return store.state.purchaseType == PurchaseType.Game
    ? 'Game Purchases'
    : store.state.purchaseType == PurchaseType.Hardware
    ? 'Hardware Purchases'
    : 'Games and Hardware Purchases';
});

onMounted(() => {
  store.dispatch(Actions.GetPurchases);
});

watch(
  route,
  () => {
    store.commit(Mutations.SetYear, parseInt(`${route.params.year}`, 10));
  },
  { deep: true },
);

const previous = () => {
  router.push(`/purchases/${store.state.year - 1}`);
};
const next = () => {
  router.push(`/purchases/${store.state.year + 1}`);
};
const togglePurchaseType = () => {
  let type = PurchaseType.All;
  switch (store.state.purchaseType) {
    case PurchaseType.Game:
      type = PurchaseType.All;
      break;
    case PurchaseType.All:
      type = PurchaseType.Hardware;
      break;
    case PurchaseType.Hardware:
      type = PurchaseType.Game;
      break;
  }
  store.commit(Mutations.SetPurchaseType, type);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TimeToolbar, {
      title: `${_unref(year)}`,
      onPrevious: previous,
      onNext: next
    }, null, 8, ["title"]),
    _createElementVNode("h3", null, [
      (_unref(filteredPurchases).length)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            textContent: _toDisplayString(_unref(filteredPurchases).length)
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        onClick: _withModifiers(togglePurchaseType, ["prevent"]),
        textContent: _toDisplayString(` ${_unref(type)}`)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/game/add" }, {
        default: _withCtx(() => [
          _createTextVNode("Add a Game")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/hardware/purchase/add" }, {
        default: _withCtx(() => [
          _createTextVNode("Add Hardware")
        ]),
        _: 1
      })
    ]),
    (_unref(filteredPurchases).length)
      ? (_openBlock(), _createElementBlock("ol", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPurchases), (purchase) => {
            return (_openBlock(), _createBlock(PurchaseItem, {
              purchase: purchase,
              key: purchase.key,
              links: !purchase.IS_PRODUCT
            }, null, 8, ["purchase", "links"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_unref(filteredPurchases).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " There are no known purchases for " + _toDisplayString(_unref(year)), 1))
      : _createCommentVNode("", true),
    (_unref(filteredPurchases).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Total " + _toDisplayString(_unref(formatPrice)(_unref(purchaseTotal))), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})